/**
 * Created by wjy on 2018-10-11
 */
// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-bind
// tslint:disable:jsx-no-string-ref
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';
import * as InfiniteScroll from 'react-infinite-scroller';
import { Pagination } from 'antd';
import ArticleService from '../../service/ArticleService/ArticleService';
import tool from '@util/tool';
import './index.scss';

const tabList = [{ status: null, text: '全部' }, { status: 3, text: '已发布' }, { status: 1, text: '草稿' }, { status: 2, text: '审核中' }, { status: 4, text: '未通过' }, { status: 5, text: '定时发布中' }];
const surfacePlot = 'https://p.ampmake.com/fed//tmp/egg-multipart-tmp/fed-server-api/2025/03/18/09/96ce09d9-076a-4fd7-9056-b23b8c50960b.jpeg';
@inject('store')
@observer
export default class ArticleList extends React.Component<any, any> {
    public currentPage: number = 1;
    public config: any = {
        // headers: {
        //     // 'X-CHJ-Token': window.sessionStorage.getItem('ACCESSTOKEN') || 'app_sign_13cf8fc55ac9407694ed46de06d49ceb',
        //     // 'X-CHJ-Deviceid': 'f06af636000000000'

        // },
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('artic-access_token')}`
        }

    };
    public constructor(props) {
        super(props);
        this.init();
    }
    public logout = () => {
        localStorage.removeItem('ACCESSTOKEN');
        localStorage.removeItem('USERINFO');
        this.props.store.logout.init().then(() => {
            this.props.store.hasLoginManage();
        });
    }
    public articleImmediatePub = (ID) => {
        const flag = confirm('立即发布这篇文章？');
        if (flag) {
            this.props.store.articleImmediatePub.init(ID, this.config).then((res) => {
                console.log('立即发布定时文章成功', res);
                this.getArticleList(1);
            }).catch((err) => {
                console.log('立即发布定时文章失败', err);
            });
        }
    }
    public deleteArticle = (ID) => {
        console.log(sessionStorage.getItem('DRAFTID'), ID);
        if (Number(sessionStorage.getItem('DRAFTID')) === ID) {
            sessionStorage.removeItem('DRAFTID');
        }
        const flag = confirm('删除内容不可修复，确定删除？');
        if (flag) {
            const config = this.config;
            this.props.store.articleDeleteModel.init(ID, config).then((res) => {
                console.log('删除文章成功', res);
                this.getArticleList(1);
            }).catch((err) => {
                console.log('删除文章失败 ', err);
            });
        }

    }
    public copyArticle = async (item) => {
        const data = await ArticleService.getDetail(item.id, {});
        await ArticleService.saveDraft({
            title: data.title,
            surfacePlot: data.surfacePlot,
            content: data.content,
            commentLimit: data.commentLimit,
        }, {});
        window.location.reload();
    }
    public getArticleList = (pageNo = 1, pageSize = 10) => {
        console.log(pageNo);
        const config = this.config;
        this.setState({
            pageStatus: '加载中 ...',
        });
        this.props.store.articleListModel.init(pageNo, pageSize, config).then((res) => {
            console.log('获取文章列表成功', res);
            this.setState({
                articleList: res.results,
                totalCount: res.totalCount,
            });

        }).catch((err) => {
            console.log('获取文章列表失败', err);
        });
    }
    public pageChange = (current, size) => {
        console.log(current, size);
        this.getArticleList(current, size);
    }
    public onShowSizeChange = (current, size) => {
        this.getArticleList(current, size);
    }
    public loadFunc = () => {
        const { articleListModel } = this.props.store;
        if (articleListModel.pageCount && this.currentPage < articleListModel.pageCount) {
            if (this.state.hasLoading) {
                this.setState({
                    hasLoading: false,
                });
                this.currentPage++;
                this.getArticleList(this.currentPage);
            }

        } else {
            this.setState({
                pageStatus: '当前已经是全部',
                hasMoreItems: false,
                hasLoading: true,
            });
        }
    }
    public tabSwitch = (index, status) => {
        window.scrollTo(0, 0);
        this.setState({
            tabindex: index,
            hasMoreItems: true,
            articleList: [],
        });

        const config = {
            params: {
                status,
            },
        };
        this.config = { ...this.config, ...config };
        this.currentPage = 1;
        this.getArticleList(this.currentPage);
    }

    public formatDate = (dataString) => {
        const dataArr = dataString.split(' ');
        const noHour = dataArr[0].split('-');
        const time = dataArr[1].split(':');
        return noHour[0] + '.' + noHour[1] + '.' + noHour[2] + ' ' + time[0] + ':' + time[1];
    }
    public getArticleStatus = (status) => {
        const statusList = {
            1: '草稿',
            2: '审核中',
            3: '已发布',
            4: '未通过',
            5: '定时发布中',
            6: '已关闭',
        };
        return statusList[status];
    }
    public getStatusStyle = (status) => {
        const statusColorObj = {
            5: { color: '#4899FF' },
            4: { color: '#FF3B30' },
            3: { color: 'rgb(111 212 91)' },
            default: { color: '#222222' }
        };

        const result = statusColorObj[status] || statusColorObj.default;
        return result;
    }
    public create = () => {
        sessionStorage.removeItem('DRAFTID');
        window.location.href = '/create';
    }

    public init() {
        this.state = {
            editorContent: '',
            src: 'http://c.hiphotos.baidu.com/image/h%3D300/sign=c635d3753efa828bce239be3cd1f41cd/0eb30f2442a7d933b29eb303a04bd11373f0018f.jpg',
            cropResult: null,
            tabindex: 0,
            pageStatus: '当前已经是全部',
            articleList: [],
            totalCount: 0,
            hasMoreItems: true,
            hasLoading: true,
            userName: '',
        };

    }

    public componentWillMount() {
        this.props.store.hasLoginManage();
        this.getArticleList(1);
        if (localStorage.getItem('USERINFO')) {
            const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
            console.log(userInfo);
            this.setState({
                userName: userInfo.nickname,
            });
        } else {
            localStorage.removeItem('ACCESSTOKEN');
            localStorage.removeItem('USERINFO');
        }

    }

    public componentDidMount() {
        const token = window.localStorage.getItem('ACCESSTOKEN');
        console.log(token);
    }

    public render() {
        const { className } = this.props;
        const { tabindex, articleList, totalCount } = this.state;
        console.log(articleList.length);
        const items = [];
        articleList.length > 0 && articleList.map((item, idx) => {
            const {groupId= '', name: groupName= ''} = item.groupVo || {};
            items.push(
                <li key={idx}>
                    <div  className="articleImg">

                        <a href={`/detail/${item.id}${item.status !== 1 && item.status !== 2 ? '?type=1' : ''}`}><img src={item.surfacePlot || surfacePlot} alt="" /></a>
                    </div>
                    <div className="articleTitleInfo">
                        <h3><a href={`/detail/${item.id}${item.status !== 1 && item.status !== 2  ? '?type=1' : ''}`}>{item.title || '无标题'}</a></h3>
                        <div className="infoCon">
                            <span>{item.status === 3 ? '发布于' : '编辑于'} {item.status === 3 && item.releaseTime ? this.formatDate(item.releaseTime) : this.formatDate(item.updateTime)}</span>
                            <span>{item.browseSum}</span>
                            <span>{item.favourSum}</span>
                            <span>{item.commentSum}</span>
                            <span>{item.collectSum}</span>
                        </div>
                        <div className="articleListCheckCon">
                            <div className="informInfo">
                            <span style={{color: item.auditDescription ? 'red' : 'green'}}>
                               {this.getArticleStatus(item.status)}
                                {item.auditDescription ? `:${item.auditDescription}` : ''}
                            </span>
                                <span style={this.getStatusStyle(item.status)}>{
                                    // this.getArticleStatus(item.status)
                                }{item.status === 4 && '：' + item.violateName}</span><span style={{ color: '#8C8985' }}>{item.status === 5 ? '将于' + this.formatDate(item.releaseTime) + '发布' : item.status === 4 ? item.rejectDesc : ''}</span>
                                <span>
                                {groupName}
                                </span>
                            </div>
                            <div className="checkBtn">
                                {/* {item.status === 5 ? <span onClick={() => this.articleImmediatePub(item.id)} style={{ color: '#222222' }}>立即发布</span> : null} */}
                                <span onClick={() => { this.copyArticle(item); }}>复制</span>
                                {item.status !== 2 && item.isEditorial !== 0 ? <span><Link to={item.status === 1 || item.status === 4 ? tool.getToDetailHref('/create', {id: item.id, groupId}) :  tool.getToDetailHref(`/update/${item.id}`, {type: item.status !== 1 && item.status !== 2 ? '1' : '', groupId})}>修改</Link></span> : null}
                                <span onClick={() => { this.deleteArticle(item.id); }}>删除</span>
                            </div>
                        </div>
                    </div>
                </li>,
            );
        });

        return (
            <div className="articleListWrap">
                {/* <div className="articleHeader">
                    <div className="headerBox">
                        <div className="articleListLogo">
                            <img src={require('../../assets/images/commonImg/logoBlackBg.png')} alt="" />
                        </div>
                        <div className="logoutBox">
                            <span className="userName">{userName || '未知'}</span><span className="logoutBut" onClick={() => this.logout()}>退出</span>
                        </div>
                    </div>

                </div> */}
                <nav className="tabCon">
                    <div className="tabBox">
                        文章状态
                        <div className="tabList">
                            {
                                tabList.map((item, idx) => {
                                    return <span key={idx} className={tabindex === idx ? 'active' : ''} onClick={() => this.tabSwitch(idx, item.status)}>{item.text}</span>;
                                })
                            }
                        </div>
                    </div>

                </nav>
                <div className="articleListBox">
                    {items.length > 0 ?
                        <ul>
                            {
                                items
                            }
                        </ul> :
                        <p style={{ textAlign: 'center', marginTop: '20px' }}>暂无数据</p>
                    }
                    {/*
                        items.length > 0 ? !this.state.hasMoreItems && <div className="loader" style={{ textAlign: 'center', color: '#8c8985', fontSize: '14px', marginTop: '10px' }} key={this.currentPage}>当前已经是全部</div> : null */}
                </div>
                <div className="page-box">
                    <Pagination size="small" onShowSizeChange={this.onShowSizeChange} onChange={this.pageChange} defaultCurrent={1} defaultPageSize={10} total={totalCount} showSizeChanger={true} showQuickJumper={true} />
                </div>
            </div>
        );
    }
}
